import React from 'react';
import { Payment, PaymentStatusLabels, PaymentStatusColors, PaymentMethodLabels } from '../types/payment';
import { formatCurrency } from '../utils/currency';

interface PaymentsListProps {
  payments: Payment[];
  onConfirmPayment?: (paymentId: string) => void;
  onCancelPayment?: (paymentId: string) => void;
  currency: string;
}

export const PaymentsList: React.FC<PaymentsListProps> = ({
  payments,
  onConfirmPayment,
  onCancelPayment,
  currency
}) => {
  if (payments.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>Платежи не найдены</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {payments.map((payment) => (
        <div key={payment.id} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
          <div className="flex justify-between items-start mb-3">
            <div>
              <h3 className="font-medium text-gray-900">
                {formatCurrency(payment.amount, currency)}
              </h3>
              <p className="text-sm text-gray-500">
                {new Date(payment.paymentDate).toLocaleDateString('ru-RU')}
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${PaymentStatusColors[payment.status]}`}>
                {PaymentStatusLabels[payment.status]}
              </span>
              {payment.status === 'PENDING' && (
                <div className="flex space-x-1">
                  <button
                    onClick={() => onConfirmPayment?.(payment.id)}
                    className="px-2 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                  >
                    Подтвердить
                  </button>
                  <button
                    onClick={() => onCancelPayment?.(payment.id)}
                    className="px-2 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700"
                  >
                    Отменить
                  </button>
                </div>
              )}
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">Метод:</span>
              <span className="ml-2 font-medium">{PaymentMethodLabels[payment.method]}</span>
            </div>
            {payment.transactionReference && (
              <div>
                <span className="text-gray-500">Ссылка:</span>
                <span className="ml-2 font-medium">{payment.transactionReference}</span>
              </div>
            )}
          </div>
          
          {payment.notes && (
            <div className="mt-3 pt-3 border-t border-gray-100">
              <span className="text-gray-500 text-sm">Примечания:</span>
              <p className="text-sm text-gray-700 mt-1">{payment.notes}</p>
            </div>
          )}
          
          {payment.processedAt && (
            <div className="mt-2 text-xs text-gray-400">
              Обработан: {new Date(payment.processedAt).toLocaleString('ru-RU')}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
